import { render } from "./Proportioncategories.vue?vue&type=template&id=2217eea1"
import script from "./Proportioncategories.vue?vue&type=script&lang=js"
export * from "./Proportioncategories.vue?vue&type=script&lang=js"

import "./Proportioncategories.vue?vue&type=style&index=0&id=2217eea1&lang=css"

import exportComponent from "/Users/ChenHao/www/xiaohangjia/zhy_dataview_fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__